import { Link, router } from "@inertiajs/react"
import { LogOut, Settings } from "lucide-react"

import {
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu"
import { UserInfo } from "@/components/user-info"
import { useMobileNavigation } from "@/hooks/use-mobile-navigation"
import { disconnectWebPushForLogout } from "@/lib/web-push"
import { destroyUserSessionPath, settingsProfilePath } from "@/routes/index"
import type { User } from "@/types"

interface UserMenuContentProps {
  auth: {
    session: {
      id: string
    } | null
    user: User | null
  }
}

export function UserMenuContent({ auth }: UserMenuContentProps) {
  const { user } = auth
  const cleanup = useMobileNavigation()

  const handleLogout = async () => {
    cleanup()
    try {
      await disconnectWebPushForLogout()
    } finally {
      router.flushAll()
      router.delete(destroyUserSessionPath())
    }
  }

  if (!user) return null

  return (
    <>
      <DropdownMenuLabel className="p-0 font-normal">
        <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
          <UserInfo user={user} showEmail={true} />
        </div>
      </DropdownMenuLabel>
      <DropdownMenuSeparator />
      <DropdownMenuGroup>
        <DropdownMenuItem asChild>
          <Link
            className="block w-full"
            href={settingsProfilePath()}
            as="button"
            prefetch
            onClick={cleanup}
          >
            <Settings className="mr-2" />
            Settings
          </Link>
        </DropdownMenuItem>
      </DropdownMenuGroup>
      <DropdownMenuSeparator />
      <DropdownMenuItem asChild>
        <button
          type="button"
          className="block w-full"
          onClick={() => void handleLogout()}
        >
          <LogOut className="mr-2" />
          Log out
        </button>
      </DropdownMenuItem>
    </>
  )
}
